export enum PublicApiAuthScope {
  OrdersRead = "orders_read",
  OrdersWrite = "orders_write",
  CustomersRead = "customers_read",
  CustomersWrite = "customers_write",
  ProductsRead = "products_read",
  ProductsWrite = "products_write",
  ReturnsRead = "returns_read",
  ReturnsWrite = "returns_write",
  WebhooksRead = "webhooks_read",
  WebhooksWrite = "webhooks_write",
  InventoryRead = "inventory_read",
  InventoryWrite = "inventory_write",
  InboundShipmentsRead = "inbound_shipments_read",
  InvoicesRead = "invoices_read",
  CustomerEventsWrite = "customer_events_write",
  StorefrontEventsWrite = "storefront_events_write",
  LocationsRead = "locations_read",
  LocationsWrite = "locations_write",
  ShippingRead = "shipping_read",
  ShippingWrite = "shipping_write",
  CampaignsRead = "campaigns_read",
  CampaignsWrite = "campaigns_write",
  MarketingAutomationsRead = "marketing_automations_read",
  MarketingAutomationsWrite = "marketing_automations_write",
  SegmentsRead = "segments_read",
  SegmentsWrite = "segments_write",
  CampaignsAnalyticsRead = "campaigns_analytics_read",
  MarketingAutomationsAnalyticsRead = "marketing_automations_analytics_read",
  ConsolidationsRead = "consolidations_read",
  MarketingTemplatesRead = "marketing_templates_read",
  MarketingTemplatesWrite = "marketing_templates_write",
  CommerceAgentKnowledgeRead = "commerce_agent_knowledge_read",
  CommerceAgentKnowledgeWrite = "commerce_agent_knowledge_write",
  CheckoutRead = "checkout_read",
  CheckoutWrite = "checkout_write",
  PickSessionsRead = "pick_sessions_read",
  CalendarEventsRead = "calendar_events_read",
  CalendarEventsWrite = "calendar_events_write",
  PaymentsRead = "payments_read",
}
